<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/admin"></ion-back-button>
    </ion-buttons>
    <ion-title>Reported Data</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <ion-segment value="All " [(ngModel)]="filter">
      <ion-segment-button value="All">
        <ion-label>All</ion-label>
      </ion-segment-button>
      <ion-segment-button value="0">
        <ion-label>New</ion-label>
      </ion-segment-button>
      <ion-segment-button value="1">
        <ion-label>Handled</ion-label>
      </ion-segment-button>
    </ion-segment>

    <div class="ion-padding ion-text-center" *ngIf="reports.length ===0">
      <ion-text color="darkmimbo">There are no reports yet.</ion-text>
    </div>

    <div *ngIf="reports.length >0">
      <ion-list>
        <ion-item *ngFor="let report of reports| reportsFilter:filter" detail color="lightmimbo" button="true"
          (click)="ViewReport(report)">
          <ion-icon name="alert-circle-outline" class="ion-item-left ion-margin-end"></ion-icon>
          <ion-label>
            <h2>{{ getType(report.type) | titlecase }} - {{ report.isHandled ? 'Handled' : 'New' }}</h2>
            <p>Reason: {{ getReason(report.reason) }}</p>
            <p>Reported: {{report.reportedUsername}} was reported by {{ report.username }}</p>
            <p>Date: {{ report.reportDate | date:'medium' }}</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>
  <div style="width: 100%; height: 70px"></div>
</ion-content>

<ion-modal class="full-ion-modal" [isOpen]="isModalOpen" #reportModal>
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()"><ion-icon name="arrow-back-outline" slot="icon-only"> </ion-icon></ion-button>
        </ion-buttons>
        <ion-title>Report Details</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" color="lightmimbo">
      <ion-grid>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Type: </b>{{getType(report.type)}} with Id:<i><strong> {{report.id}}</strong></i></p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Reason: </b>{{getReason(report.reason)}}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Status: </b>{{ report.isHandled ? 'Handled' : 'New' }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Reported On: </b>{{ report.reportDate | date:'medium' }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Reported By: </b>{{report.username}} with Id:<i><strong> {{report.userId}}</strong></i></p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Reported User: </b>{{report.reportedUsername}} with Id:<i><strong>
                  {{report.reportedUserId}}</strong></i></p>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="report.isHandled">
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Handled On: </b>{{ report.handledDate | date:'medium' }}</p>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="report.type.toLowerCase().includes('comment')">
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
            <p><b>Comment: </b>{{ report.commentText }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button (click)="gotToLink()"><ion-icon name="eye-outline" slot="start"></ion-icon>
              View Data
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button (click)="markHandled()"><ion-icon name="checkmark-outline" slot="start"></ion-icon>
              Mark as Handled
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
            <ion-button (click)="deleteReport()" color="danger"><ion-icon name="trash-outline" slot="start"></ion-icon>
              Delete Report
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ng-template>
</ion-modal>